module.exports = __webpack_public_path__ + "img/oak-testnet.926bfb6a.png";